import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.ESTA_O_AQUELLA;

export const NUM_QUESTIONS_WORDS = 5;

export const NUM_QUESTIONS_IMAGES = 5;

export const NUM_QUESTIONS = NUM_QUESTIONS_WORDS + NUM_QUESTIONS_IMAGES;

export const MASTER_CRITERIA = NUM_QUESTIONS - 1;

// Onboarding C vs QU for levels 1-4; B vs V for levels 5+
export const INITIAL_ONBOARDING_LEVELS = [0, 1, 2, 3, 4];

// Only show instruction/practice for C vs QU levels
export const INSTRUCTION_PRACTICE_LEVELS = [1, 2, 3, 4];

export const CATEGORIES = {
  C: 'c',
  Q: 'q',
  QU: 'qu', // instruction only
  C_Q: 'c_q',
  B_V: 'b_v',
  G_J: 'g_j',
  LL_Y: 'll_y',
  H_VOWEL: 'h_vocal',
  S_Z: 's_z',
  C_S: 'c_s',
};

export const ONBOARDING_CATEGORIES = {
  C_Q: 'c_q',
  B_V: 'b_v',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  PRACTICE: 'PRACTICE',
  INSTRUCTION: 'INSTRUCTION',
  ONBOARDING: 'ONBOARDING',
  ONBOARDING_REPEAT: 'ONBOARDING_REPEAT',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
};

export const ITEM_TYPES = {
  WORD: 'Word',
  IMAGE: 'Image',
};

export const BACKGROUNDS = {
  ICE_CREAM: 'IceCreamParlor',
  MOVIES: 'MovieTheatre',
};

// 2 backgrounds - loop with progression: ice cream, movies, movies, ice cream
export const BACKGROUND_ROUND_LOOP = {
  ICE_CREAM: [0, 1],
  MOVIES: [2, 3],
};

export const POSITION_Y_IMAGE_BY_INDEX = {
  0: -395,
  1: -265,
  2: -135,
  3: -135,
  4: -5,
};

// Alex states
export const ALEX_STATES = {
  INACTIVE: 0,
  ACTIVE: 1,
  SPEAKING: 2,
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SET_ITEM_TYPE: 'SET_ITEM_TYPE',
  SET_BACKGROUND_TYPE: 'SET_BACKGROUND_TYPE',
  INIT_ROUND_WORDS: 'INIT_ROUND_WORDS',
  INIT_ROUND_IMAGES: 'INIT_ROUND_IMAGES',
  SET_HAS_SEEN_ONBOARDING: 'SET_HAS_SEEN_ONBOARDING',
  MOVE_TO_CATEGORY: 'MOVE_TO_CATEGORY',
  INCREMENT_QUESTIONS_ANSWERED: 'INCREMENT_QUESTIONS_ANSWERED',
  INCREMENT_ANSWERS_CORRECT: 'INCREMENT_ANSWERS_CORRECT',
  INCREMENT_ANSWERS_INCORRECT: 'INCREMENT_ANSWERS_INCORRECT',
  INCREMENT_ATTEMPTS_COUNTER: 'INCREMENT_ATTEMPTS_COUNTER',
  NEXT_QUEUE_ITEM: 'NEXT_QUEUE_ITEM',
  INIT_LAYOUT: 'INIT_LAYOUT',
  SET_DROP_ANIMATION_STARTED: 'SET_DROP_ANIMATION_STARTED',
  SET_LAST_LEVEL_MASTERED: 'SET_LAST_LEVEL_MASTERED',
  SET_INTERACTION_LOCKED: 'SET_INTERACTION_LOCKED',
  SET_LEVEL_MASTERED: 'SET_LEVEL_MASTERED',
  NEXT_PRACTICE_ITEM: 'NEXT_PRACTICE_ITEM',
  SET_SELECTED_CATEGORY: 'SET_SELECTED_CATEGORY',
  ADD_PRACTICE_QUESTION: 'ADD_PRACTICE_QUESTION',
  START_PRACTICE: 'START_PRACTICE',
  RESET_PRACTICE: 'RESET_PRACTICE',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  SET_ALEX_ACTIVE: 'SET_ALEX_ACTIVE',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  SET_PRACTICE_INTERACTION_LOCKED: 'SET_PRACTICE_INTERACTION_LOCKED',
  INCREMENT_PRACTICE_QUESTIONS_ANSWERED: 'INCREMENT_PRACTICE_QUESTIONS_ANSWERED',
  SET_COLUMN_INDEX: 'SET_COLUMN_INDEX',
  SET_MAGNIFIED_CELL: 'SET_MAGNIFIED_CELL',
  SET_HIGHLIGHTED_CELL: 'SET_HIGHLIGHTED_CELL',
  SET_ROW_INDEX: 'SET_ROW_INDEX',
  INIT_INSTRUCTION: 'INIT_INSTRUCTION',
  SET_HIDDEN_CELLS: 'SET_HIDDEN_CELLS',
  CHANGE_INSTRUCTION_STAGE: 'CHANGE_INSTRUCTION_STAGE',
  ADD_CELLS: 'ADD_CELLS',
  UPDATE_CELL_POSITION: 'UPDATE_CELL_POSITION',
  MOVE_COLUMN: 'MOVE_COLUMN',
  REMOVE_CELLS: 'REMOVE_CELLS',
  INIT_ONBOARDING_WORDS: 'INIT_ONBOARDING_WORDS',
  INIT_ONBOARDING_IMAGES: 'INIT_ONBOARDING_IMAGES',
  SET_HIGHLIGHTED_ONBOARDING_CATEGORY: 'SET_HIGHLIGHTED_ONBOARDING_CATEGORY',
  NEXT_ONBOARDING_ITEM: 'NEXT_ONBOARDING_ITEM',
  SET_HIGHLIGHTED_ONBOARDING_ARROW: 'SET_HIGHLIGHTED_ONBOARDING_ARROW',
  MOVE_TO_ONBOARDIBNG_CATEGORY: 'MOVE_TO_ONBOARDIBNG_CATEGORY',
  SET_ONBOARDING_INTERACTION_LOCKED: 'SET_ONBOARDING_INTERACTION_LOCKED',
  SET_COLUMN_SHIFT_STEP: 'SET_COLUMN_SHIFT_STEP',
  SET_LEVEL_COUNT: 'SET_LEVEL_COUNT',
  CHANGE_SET_NUMBER: 'CHANGE_SET_NUMBER',
};

export const INSTRUCTION_STAGES = {
  INTRO: 'INTRO',
  INIT_GRID: 'INIT_GRID',
};
export const POSITION_X_TEXT_WRAPPER_BY_INDEX = {
  0: -430,
  1: -330,
  2: -210,
  3: -115,
  4: -10,
};
